import { Component, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TranslateService } from "@ngx-translate/core";
import { Claims } from 'src/app/_models/common/claims';
import { Router, ActivatedRoute } from "@angular/router";
import { IApiRequest, ApiRequest } from 'src/app/_models';
import { ClaimsService } from 'src/app/_services/common/claims.service';
import { OrgBasicFunctionSubscriptionService } from 'src/app/_services/billing-pricing/Org-BasicFunction-Subscription.service';
import { ICONS } from 'src/app/_helpers/icons.constants';
import { ModalComponent } from 'src/app/shared/design-system/modal/modal.component';
import { ModalConfig } from "src/app/shared/design-system/modal/modal.modal";
import { ButtonComponent } from 'src/app/shared/design-system/button/button.component';

@Component({
  selector: 'trial-end-alert-panel',
  templateUrl: './trial-end-alert-panel.component.html',
  standalone: true,
  imports: [TranslateModule,ModalComponent,ButtonComponent]
})
export class TrialEndAlertPanelComponent implements OnInit {

  public readonly ICONS = ICONS;

  claims!: Claims;
  showModalPopup = false;
  basicFunctionRemainingTrialDays!: number;
  modalConfig!: ModalConfig;
  public addYourCardButton: any;

  constructor(
    private claimsService: ClaimsService,
    private router: Router,
    private orgBasicFunctionSubscriptionService: OrgBasicFunctionSubscriptionService,
    private translate: TranslateService
  ) {
    this.claimsService.currentClaims.subscribe((claims) => {
      this.claims = claims;
    });
  }

  ngOnInit(): void {
    this.fnGetOrgBasicFunctionSubscriptionTrialDetails();
  }

  fnModalControls(){
     this.modalConfig = {
        visible: this.showModalPopup,
        title: this.translate.instant('ess_trial_end_alert_text1'),
        variant: "error",
        headerIconSrc: ICONS.ALERT_CIRCLE,
        headerIconAltOverride: "Completed",
        hiddenCloseIcon: true
     };

     this.addYourCardButton = {
        id:"btnAddYourCard",
        label:this.translate.instant('add_your_card') ,
        color: "primary",
        size: "md",
        block: true
      };
  }

  fnShowModal(){
    this.showModalPopup = true;
    this.fnModalControls();
  }

   fnGetOrgBasicFunctionSubscriptionTrialDetails(): void {
    if (!this.claims?.OrgId) {
      return;
    }

    this.orgBasicFunctionSubscriptionService
      .GetOrgBasicFunctionSubscriptionTrialDetails(this.claims.OrgId)
      .subscribe((res: any) => {
        if (res?.responseInfo) {
          this.basicFunctionRemainingTrialDays = res.responseInfo.basicFunctionRemainingTrialDays;
            this.fnShowModal();
        }
      });
  }

  fnSubscribeNow(): void {
    if (this.claims?.BandId > 0) {
      this.router.navigate(['/essential-pack']);
    }
  }
}
